import React, { useContext } from 'react'
import { PageHeader } from '@pushly/aqe/lib/components'
import { ConfigProvider } from 'antd'
import { useLocation } from 'react-router-dom'
import { useService } from '@pushly/aqe/lib/hooks/use-service'
import { AppService } from '../../services'
import { OrgContext } from '../../contexts/org-context'
import { SettingsLayout } from '../settings/settings-layout'
import { IOrgSettingsContext, ORG_SETTINGS_GROUPS, ORG_SETTINGS_PAGES } from '../settings/org-registry'

export const Account: React.FC = () => {
    const appSvc = useService(AppService)
    const { org } = useContext(OrgContext)
    const { hash, pathname } = useLocation()

    return (
        <div className="sw-page single-account">
            <div className="sw-page-wrapper">
                <PageHeader title="Settings" onTitleSet={appSvc.customizeTabTitle} append={<span>ID: {org.id}</span>} />
                <ConfigProvider
                    theme={{
                        components: {
                            Form: {
                                itemMarginBottom: 0,
                                labelColor: 'var(--ant-color-secondary)',
                            },
                        },
                    }}
                >
                    <SettingsLayout<IOrgSettingsContext>
                        hash={hash}
                        context={{ org }}
                        pages={ORG_SETTINGS_PAGES}
                        groups={ORG_SETTINGS_GROUPS}
                        iconContext="org"
                        onNavigate={(key) => appSvc.route(`${pathname}#${key}`)}
                    />
                </ConfigProvider>
            </div>
        </div>
    )
}
